import type { i18n as I18n } from "i18next";

/**
 * Keeps `<html lang>` on the UI language, so screen readers, hyphenation and
 * the browser's spell checker read the page in the language it is written in.
 * Call once, right after `i18n.init`.
 */
export const bindDocumentLanguage = (
  i18n: I18n,
  root: HTMLElement = document.documentElement
): void => {
  const apply = (language: string | undefined): void => {
    if (language) root.lang = language;
  };
  apply(i18n.language);
  i18n.on("languageChanged", apply);
};
